/**
 * Splash Screen control.
 *
 * 네이티브 PNG splash 는 WebView 로딩 중에만 잠깐 보이고, React 가 마운트되어
 * AppSplash 컴포넌트가 첫 paint 직후 hideSplash() 를 호출하면 즉시 hide 된다.
 * AppSplash 가 동일 디자인으로 받아 통통튀는 애니메이션을 재생.
 *
 * 이 모듈은 안전망 timeout 만 유지 — JS 가 죽거나 AppSplash 가 mount 안 되는
 * 상황에서도 splash 가 영구히 남지 않도록.
 */
import { isNative, nativeWarn } from "./index";

const SAFETY_TIMEOUT_MS = 5000;

let hidden = false;

export async function hideSplash(): Promise<void> {
  if (!isNative() || hidden) return;
  hidden = true;
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide({ fadeOutDuration: 0 });
  } catch (err) {
    nativeWarn("splash:hide", err);
  }
}

export async function showSplash(): Promise<void> {
  if (!isNative()) return;
  hidden = false;
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.show({ autoHide: false });
  } catch (err) {
    nativeWarn("splash:show", err);
  }
}

export function initSplashControl(): void {
  if (!isNative()) return;

  // AppSplash 가 정상 mount 되면 즉시 hide. 안전망으로 5s 타임아웃.
  setTimeout(() => void hideSplash(), SAFETY_TIMEOUT_MS);
}
